/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

import AuthService from "@/services/authService";

const getters = {
  // COMPONENT
  // vx-autosuggest
  starredPages: (state) =>
    state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: (state) => {
    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1200) return "xl";
    else if (state.windowWidth >= 992) return "lg";
    else if (state.windowWidth >= 768) return "md";
    else if (state.windowWidth >= 576) return "sm";
    else return "xs";
  },

  scrollbarTag: (state) => {
    return state.is_touch_device ? "div" : "VuePerfectScrollbar";
  },

  getAddonFlag: (state) => (key) => {
    return state.addons.some((addon) => {
      return addon.id === AuthService.ADDON_IDS[key];
    });
  },
  /**
   * for_signalコレクションを取得するか調べる
   * @param {*} state
   */
  vesselPositionCollection: (state) => {
    const isSignal = state.addons.some((addon) => {
      return addon.id === AuthService.ADDON_IDS["GKMG_AIS_FOR_SIGNAL"];
    });
    return isSignal ? "vessel_position_for_signal" : "vessel_position";
  },
  /**
   * for_signalが有効か調べる
   * @param {*} state
   */
  isSignal: (state) => {
    const isSignal = state.addons.some((addon) => {
      return addon.id === AuthService.ADDON_IDS["GKMG_AIS_FOR_SIGNAL"];
    });
    return isSignal;
  },

  getMenuItems:
    (_state, { isPaid }) =>
    async (menuItems) => {
      const hasEcoShip = await AuthService.hasAddon(
        AuthService.ADDON_IDS.ECO_SHIP,
      );
      let addons = await AuthService.getAddons();
      addons = hasEcoShip
        ? addons.filter(
            (s) => !(s.id === AuthService.ADDON_IDS.SECURE_DATAFLOW),
          )
        : addons;

      let result = menuItems.filter(function (value) {
        if (!value.isAddon) return value;
        for (let item in this) {
          if (this[item].name === value.slug) return value;
        }
      }, addons);

      result = isPaid
        ? result
        : result.map((item) => {
            const isDisabled = checkDisabled(isPaid)(item.isFreeContent);
            return {
              ...item,
              isDisabled,
              localIcon:
                (isDisabled && item.disabledLocalUrl !== undefined) ||
                item.localIcon,
              localUrl: getLocalUrl(isDisabled)(item.disabledLocalUrl)(
                item.localUrl,
              ),
            };
          });

      const { CREW_TIER1, CREW_TIER2, CREW_TIER3 } = AuthService.ADDON_IDS;
      const tiers = addons.filter((addon) =>
        [CREW_TIER1, CREW_TIER2, CREW_TIER3].includes(addon.id),
      );
      const isExistingUser = tiers && tiers.length <= 0;
      result = isExistingUser
        ? result.filter((item) => item.slug !== "crews")
        : result;
      return result;
    },

  isPaid: (state) => {
    return state.isFree !== true;
  },
};

const checkDisabled = (isPaid) => (isFreeContent) => !(isPaid || isFreeContent);
const getLocalUrl = (isDisabled) => (disabledLocalUrl) => (localUrl) =>
  isDisabled && disabledLocalUrl ? disabledLocalUrl : localUrl;

export default getters;
